<flex-column>
  <mat-toolbar color="primary">
    <span>Event Staffing</span>
    <span style="flex: 1"></span>
    @if (authService.authenticated | async) { @if (showHome) {
    <a mat-button routerLink="/home">Home</a>
    } @if (showAdmin) {
    <a mat-button routerLink="/admin">Admin</a>
    } @if (showConfiguration) {
    <a mat-button routerLink="/configuration">Configuration</a>
    } @if (showProcessAdmin) {
    <a mat-button routerLink="/process-admin">Process Admin</a>
    } @if (!showHome) {
    <a mat-button routerLink="/my-tasks">My Tasks</a>
    }
    <a mat-button routerLink="/profile">Profile</a>
    <avatar></avatar>
    }
  </mat-toolbar>
  <div grow style="padding: 0 16px">
    <router-outlet></router-outlet>
  </div>
</flex-column>
